import * as z from 'zod';

export const deliveryMethodQuerySchema = z.enum(['USPS', 'UPS', 'FedEx', 'In-Person', 'Other']).or(z.string());

type DeliveryMethodQuerySchema = z.infer<typeof deliveryMethodQuerySchema>;
export type DeliveryMethodMutationSchema = DeliveryMethodQuerySchema;

export const deliveryMethodFormSchema = z.object({
  name: z.string(),
  value: deliveryMethodQuerySchema,
});

type DeliveryMethodFormSchema = z.infer<typeof deliveryMethodFormSchema>;

export const defaultDeliveryMethod = null;

export const deliveryMethodOptions: DeliveryMethodFormSchema[] = [
  { name: 'USPS', value: 'USPS' },
  { name: 'UPS', value: 'UPS' },
  { name: 'FedEx', value: 'FedEx' },
  { name: 'In-Person', value: 'In-Person' },
  { name: 'Other', value: 'Other' },
];

export function strToDeliveryMethod(deliveryMethod: DeliveryMethodQuerySchema | null): DeliveryMethodFormSchema | null {
  return (
    deliveryMethodOptions.find((option) => option?.value === deliveryMethod) ??
    (typeof deliveryMethod === 'string' ? { name: deliveryMethod, value: deliveryMethod } : null)
  );
}

export function deliveryMethodToStr(deliveryMethod: DeliveryMethodFormSchema | null) {
  return deliveryMethod?.value ?? null;
}
